export const CATEGORIAS = [
  { value: 'guia-1', label: 'Guia 1 - Prod. Técnicos' },
  { value: 'guia-1b', label: 'Guia 1B - Tintas' },
  { value: 'guia-2', label: 'Guia 2 - Revenda' },
  { value: 'guia-3', label: 'Guia 3 - Uso Interno' },
  { value: 'guia-4', label: 'Guia 4 - Limpeza' },
  { value: 'guia-5', label: 'Guia 5 - Copa' },
  { value: 'guia-6', label: 'Guia 6 - Escritório' },
  { value: 'guia-7', label: 'Guia 7 - Descartáveis' },
  { value: 'guia-8', label: 'Guia 8 - Reforma' }
];

export const UNIDADES = [
  { value: 'un', label: 'Unidade (un)' },
  { value: 'ml', label: 'Mililitros (ml)' },
  { value: 'g', label: 'Gramas (g)' },
  { value: 'kg', label: 'Quilogramas (kg)' },
  { value: 'l', label: 'Litros (L)' },
  { value: 'cx', label: 'Caixa (cx)' },
  { value: 'pct', label: 'Pacote (pct)' },
  { value: 'par', label: 'Par' },
  { value: 'rolo', label: 'Rolo' }
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getCategoriaLabel = (value) => {
  const cat = CATEGORIAS.find(c => c.value === value);
  return cat ? cat.label : value || '-';
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);
};
